import { FC, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper/core';
import { getNameByKey } from '../../../../../lib/utils/UtilsCommon';
SwiperCore.use([Autoplay]);
import 'swiper/swiper.less';
import './style.less';

interface IProps {
  classNames?: string,
}
/** 品牌报道 */
const BrandReport: FC<IProps> = ({classNames}) => {
  const swipeRef = useRef(null);
  const list = [
    {
      channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/W97SAEB4-Q7YO-FV4S-1763626434861-NQY2PLRSYWMT.png?x-oss-process=image/format,webp',
      title: '银发兴趣教育如何定义“高质量”？兴趣岛荣获全国质量月质量诚信倡议企业',
      content: '2025年10月，在国家市场监督管理总局等26部门联合开展的全国“质量月”活动中，兴趣岛凭借在银发兴趣教育领域对师资筛选、课程研发与服务体系的全链条高质量把控，获得中国质量检验协会颁发的两项荣誉：“全国质量月质量诚信倡议企业” 和 “全国产品和服务质量诚信品牌”。',
      link: 'http://www.chinatt315.org.cn/rdgz/2025-11/11/257408.html',
    },
    {
      channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/2WUTG19V-2SEY-ST3F-1763622655956-EXDDTB2XMOPR.png?x-oss-process=image/format,webp',
      title: '重阳节，《乐龄族兴趣生活方式图鉴》广州发布',
      content: '2025年10月29日，重阳佳节，兴趣岛发布聚焦40-70岁人群兴趣生活的《乐龄族兴趣生活方式图鉴》，并同步揭牌成立兴趣生活研究院，获得人民日报记者关注报道。这份图鉴，通过平台超3500万用户的数据调研，描绘了当代乐龄群体突破年龄界限、通过兴趣学习重塑生活方式的新图景。',
      link: 'https://www.peopleapp.com/column/30050631310-500007173063',
    },
    {
		channelImg:'https://media.qianliaowang.com/xqd/tools/activity/image/2025061211/SM4SIVHW-9B5M-LV7P-1749695996166-WJOWWOGYNQYK.png?x-oss-process=image/format,webp',
		title:'广州打造银发消费IP 与兴趣岛等领军企业共推银发经济发展',
		content:'6月3日，央级媒体消费日报发布报道，讲述兴趣岛受邀出席日前举办的广州首届银龄艺术季启动仪式暨天河区选拔赛，并助力本届艺术季举办。现场，兴趣岛副总裁林景接受广东电视台采访，天河区领导一行参观兴趣岛展台并进行工作指导。消费日报指出，兴趣岛与银龄艺术季的合作模式，已然成为推动银发经济发展的全新范式。',
		link:'http://www.xfrb.com.cn/article/council/15291510638980.html',
    },
    {
		channelImg:'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/JK1MDJ7Z-FYJV-D3JB-1763626382821-4VDVVG3ZLCV9.png?x-oss-process=image/format,webp',
		title:'广州上百人登山练太极，“文化+游学”受关注',
		content:'9月19日，央级媒体新华网发布报道，讲述兴趣岛武当太极游学活动盛况，及其对响应国家号召弘扬中国传统文化的意义。',
		link:'https://app.xinhuanet.com/news/article.html?articleId=2f0eb7588363f1bdc0175cbdd4340640&timestamp=88759',
    },
    {
		channelImg:'https://img.qlchat.com/qlLive/activity/image/EIAY848U-7ZO3-VWHU-1715420664347-5D6TM1XE6D35.png?x-oss-process=image/format,webp',
		title:'兴趣岛亮相2024广州文交会，共同构建多领域创新发展新格局',
		content:'9月27日-29日，2024广州文化产业交易会在广交会展馆举办。期间，兴趣岛展出企业如何通过中华优秀传统文化激发银发一族的兴趣文化空间，并荣获2024年“广州文化企业30强”称号。',
		link:'http://news.china.com.cn/mts/2024-10/08/content_1195793.htm',
    },
    {
		channelImg:'https://media.qianliaowang.com/qlLive/activity/image/FP6VEO4D-ZVAW-TIP8-1731044852473-QQ9DOL5QHH4Z.png?x-oss-process=image/format,webp',
		title:'兴趣岛受邀参加2024中国数字文娱大会',
		content:'今年8月，2024年中国数字文娱大会在广州市天河区开幕，'+ getNameByKey('comp') +'（以下简称兴趣岛）受邀参加，体现了文娱行业和政府单位对兴趣岛创新实力和行业影响力的认可。',
		link:'https://app.ceweekly.cn/h5/#/pages/detail/articleDetail/articleDetail?id=453025&share=1',
    },
    {
		channelImg:'https://media.qianliaowang.com/qlLive/activity/image/4731W64J-5PRQ-IAWU-1731044854422-NBBA1F1Y211S.png?x-oss-process=image/format,webp',
		title:'兴趣岛终南山武当太极活动：边游边学，让更多人感受太极之美',
		content:'10月18日，兴趣岛武当太极终南山站“强身心溯文化共作武当太极传承人”活动今年已举办第三次，本次活动带领近百位银龄人群感受武当太极非遗之美，被国家文旅部直属媒体《文旅中国》深度报道并高度评价本次活动让传统武术有了新的“打开方式”。',
		link:'https://share.ccmapp.cn/shareDetail?1=1&action=opendetail%3Brichtext%3B671e0bdc56be8b58b018b24e&siteId=2',
    },
    {
		channelImg:'https://media.qianliaowang.com/qlLive/activity/image/MLOPCT67-GBK4-NWUO-1731044850458-CIQ5JIPXS6PS.png?x-oss-process=image/format,webp',
		title:'东方智慧与现代生活深度融合，兴趣岛武当太极蔚然成风',
		content:'10月30日，中宣部新华社《半月谈》发长文深度报道兴趣岛武当太极是东方智慧与现代生活深度融合，据悉，《半月谈》被誉为"中华第一刊"，是中宣部委托新华社主办的重要党刊，本报道对于兴趣岛媒体传播极具影响力。',
		link:'https://mp.weixin.qq.com/s/Dc6zZ_Nma7hhxnLwMv65DQ',
    },
    {
		channelImg:'https://media.qianliaowang.com/qlLive/activity/image/DL9LWEBE-WNBD-16DV-1743676374320-U8UCR3AIZRO5.png?x-oss-process=image/format,webp',
		title:'2025兴趣岛艺术节启幕，深耕银龄文化服务探索"第二人生"无限精彩',
		content:'3月28日，央级媒体中国日报网发布报道，讲述2025兴趣岛艺术节现场盛况，聚焦兴趣岛名师更多，指出兴趣岛组建名师团队，通过高质量的专业教学，帮助银龄群体在多个艺术兴趣领域突破自我。',
		link:'https://cnews.chinadaily.com.cn/a/202503/28/WS67e6384aa31008317a2af1b4.html',
    },
	{
		channelImg:'https://img.qlchat.com/xqd/tools/activity/image/2025090211/4A7A1FL9-PP2D-G8DZ-1756794914980-421SQHDFNOS8.png',
		title:'银发经济观察丨兴趣岛：用“创新+标准”构建在线兴趣学习行业标杆',
		content:'8月26日，国内消费经济领域中唯一全国性综合日报《消费日报》发布报道，讲述兴趣岛受邀参展第九届中国（广州）国际养老健康产业博览会，凭借“创新+标准”构建在线兴趣学习行业标杆，荣获大会双项大奖。消费日报指出，兴趣岛为用户提供丰富精神文化生活的服务同时，持续发挥行业影响力，共同构建更健康、安全、有保障的标准化服务，让银发群体在提升自身生活幸福感、提振消费信心。',
		link:'https://mp.weixin.qq.com/s/mgL4eIrwYyOoh-r0uaDl3Q',
	},
	{
		channelImg:'https://img.qlchat.com/xqd/tools/activity/image/2025090211/E1POGY8Z-5ZLZ-DLEE-1756785374797-UAC63YZN5XSH.png',
		title:'满足高品质养老需求 业界打造全新兴趣生活体验',
		content:'8月28日，央媒人民网发布报道，讲述兴趣岛广州城市中心的落成，是兴趣岛从线上迈向线上线下融合发展的关键一步，更是对“让兴趣滋养生活”理念的重要践行。人民网指出，兴趣岛结合用户服务体验的洞察，打造“线上学习+线下参与”的一站式兴趣学习方式，把兴趣生活方式融入中老年日常，为中老年群体创造美好的精神生活。',
		link:'http://finance.people.com.cn/n1/2025/0828/c1004-40552136.html',
    },
    {
      channelImg: 'https://media.qianliaowang.com/xqd/tools/activity/image/2025112011/EWIKGC7I-5EF6-NEKA-1763622663426-5U58ZBEJSTQW.png?x-oss-process=image/format,webp',
      title: '新消费图鉴 银发消费“上新” 服务供给加速升级',
      content: '2025年11月14日，中央广播电视总台CCTV-13《新闻直播间》聚焦中老年兴趣消费，深度解码了兴趣岛如何通过数字技术赋能兴趣学习，帮助银发族跨越 "数字鸿沟"，开启 "第二人生" 的精彩画卷。央视新闻的关注，既彰显了兴趣岛创新实践的行业价值，更印证了其“以用户为中心” 的核心理念，正与主流价值体系形成深度共鸣。',
      link: 'https://tv.cctv.com/2025/11/14/VIDEUAElS7GUbjzppUmqyRVr251114.shtml?spm=C53156045404.PKXC0xLPAnP9.0.0',
    },
  ];

  const onSlidePrev = ()=>{
    swipeRef.current?.slidePrev?.();
  }

  const onSlideNext = ()=>{
    swipeRef.current?.slideNext?.();
  }

  const changeAutoPlay = () => {
    if(!swipeRef.current.autoplay.running){
      swipeRef.current.autoplay?.start?.();
    }else{
      swipeRef.current.autoplay?.stop?.();
    }
  }

  const getSwipeInstance = (swiper)=>{
    swipeRef.current = swiper;
  }

	return (
		<div className={`home-brand-report-container ${classNames}`}>
      <div className="brand-report-list">
        <div className='brand-report-prev flex-center' onClick={onSlidePrev}><i className="iconfont iconxiaojiantou to-left"></i></div>
        <div className='brand-report-next flex-center' onClick={onSlideNext}><i className="iconfont iconxiaojiantou"></i></div>
        <Swiper
          onSwiper={getSwipeInstance}
          // navigation={true}
          slidesPerView={'auto'}
          loop={true}
          observer
          observeParents
          observeSlideChildren
          centeredSlides
          spaceBetween={48}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          className="brand-report-swiper">
          {list.map((item: any, index: number): any => (
            <SwiperSlide key={index} className="brand-report-slide">
              <div
                className="brand-report-item"
                key={index}
                onMouseOver={changeAutoPlay}
                onMouseOut={changeAutoPlay}
                onClick={() => window.open(item?.link)}
                >
                <div className='report-item-wrap'>
                  <img className='channel-img' src={item.channelImg} />
                  <div className='title'>{item.title}</div>
                  <div className='content'>
                    {item.content}
                  </div>
                </div>
                <div className='view-detail-text flex-center'>
                  查看详情
                  <i className="iconfont iconxiaojiantou"></i>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
		</div>
	);
};
export default BrandReport;
